export default {
  Nearly30Day: 'Past 30 Days',
  Operator: 'Operator',
  ControlSize:'Control Granularity',
  ControlOperat:'Control Operations',
  DomainControlContent:'Domain Control Content',
  QuintupleControlContent: ' 5-tuple Control Content',
  RelatedRule:'Association Rules',
  OperatTime: 'Operating time',
  ControlLog: 'Control Log',
  FlowControlRule:'Traffic Control Rules',
  SearchPH: 'Search source IP/ Source port / Destination IP/ Destination port / Domain name / Rule name',
  Ban: 'Ban',
  ControlOperating: 'Control Operations',
  AlertPrompt: 'The control log shows the operation records of disabling and unblocking of traffic control rules, helping you to record the control behavior and control details information, which can be used for the audit of Internet behavior control.'
}